import { AddressCard } from 'modules/address/components'
import { Button, Loading, Modal } from 'components/ui'
import { Address } from 'framework/address'
import { FC, useEffect, useState } from 'react'
import { CustomerService } from 'modules/customers/services'
import { AddressService } from 'modules/address/services'
import { useUserSession } from 'hooks/use-user-session'
import { User } from 'framework/users'
import cn from 'classnames'
import parser from 'fazendinha/address'
import type { AddressHandlerProps } from '.'
import s from './address-handler.module.css'
import { AddressEditor } from '.'
import { useCart, useMercadinho, useNotification } from 'hooks/index'
import { ROUTE_USER_ACCOUNT, ROUTE_USER_AFFILIATE_REGISTRATION } from 'routes/user'

function normalizeZipCode(zipCode: string): string {
  return zipCode ? zipCode.replace(/-/g, '') : '';
}

const AddressHandler: FC<AddressHandlerProps> = ({ id, onSelectAddress, title = '', hasOnlyExpItems = false }) => {
  const { user } = useUserSession()
  const [newAddress, setNewAddress] = useState<Address | null>(null);

  const [addresses, setAddresses] = useState<Array<Address>>([])
  const [edit, setEdit] = useState<Address>(null as unknown as Address)
  const [loading, setLoading] = useState<boolean>(false);
  const [zipCodeNotFound, setZipCodeNotFound] = useState<boolean>(false);
  const { isMercadinho } = useMercadinho();

  const customerService = new CustomerService();
  customerService.setCustomer(user as User)
  const adressService = new AddressService()
  adressService.setCustomerId(customerService.getCustomer()?.id || '')
  const cart = useCart();

  const path = window.location.pathname;

  const { notify } = useNotification();

  async function getUserAddresses() {
    try {
      setLoading(true)
      const data: any = await adressService.list()
      const addressList: Array<Address> = parser(data.data.addresses as any)

      if(hasOnlyExpItems || isMercadinho) {
        setAddresses(addressList.filter((address) => address.type === "COBRANCA"));
      } else {
        setAddresses(addressList)
      }

      if (hasOnlyExpItems || isMercadinho) {
        const billingAddress = addressList.find((address) => address.type === "COBRANCA");

        if (billingAddress) {
          onSelectAddress(billingAddress);
          window.localStorage.setItem('selectedAddress', JSON.stringify(billingAddress));
        } else {
          openCreateAddressForm();
        }
      } else {
        const preSelectedZipCodeAddress = addressList.find((item: Address) =>
          localStorage.getItem('selectedAddress') ?
          JSON.parse(localStorage.getItem('selectedAddress') as string).id == item.id :
          normalizeZipCode(item.zipCode) === normalizeZipCode(cart.zipCode) || item.id === id
        );

        if (addressList.length > 0) {
          if (preSelectedZipCodeAddress) {
            onSelectAddress(preSelectedZipCodeAddress)
          } else if (addressList.length === 1) {
            onSelectAddress(addressList[0]);
            if (path !== ROUTE_USER_ACCOUNT && path !== ROUTE_USER_AFFILIATE_REGISTRATION) {
              notify({ title: "Endereço selecionado", description: `Usando "${addressList[0].recipient}" como endereço de entrega`, type: "info" });
            }
          } else {
            if (path !== ROUTE_USER_ACCOUNT && path !== ROUTE_USER_AFFILIATE_REGISTRATION) {
              notify({ title: "Selecione um endereço", description: "Nenhum endereço corresponde ao CEP buscado. Selecione um dos seus endereços abaixo.", type: "warning" });
            }
          }
        } else {
          openCreateAddressForm();
        }
      }

      return addressList;
    } catch (e) {
      return [];
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getUserAddresses()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newAddress])

  function cancel() {
    setEdit(null as unknown as Address)
  }

  function setAddress(address: Address) {
    onSelectAddress(address)
    getUserAddresses()
    cancel()
  }

  function openCreateAddressForm() {
    setEdit({} as unknown as Address)
  }

  async function onSuccess(address: Address) {
    const updatedAddresses = await getUserAddresses();
    console.log("updatedAddresses", updatedAddresses)
    const newAddress = updatedAddresses.find((item: Address) => normalizeZipCode(item.zipCode) === normalizeZipCode(address.zipCode)) as Address;
    console.log("newAddress", newAddress)
    setAddress(newAddress)
    setNewAddress(newAddress)
    setEdit(null as unknown as Address);
    if (setZipCodeNotFound && normalizeZipCode(address.zipCode) === normalizeZipCode(cart.zipCode)) {
      setZipCodeNotFound(false);
    }
  }

  return (
    <>
      {loading && <Loading />}
      <Modal onClose={cancel} open={!!edit}>
        <AddressEditor
          defaultZipCode={zipCodeNotFound ? cart.zipCode : ''}
          recipient={customerService.getCustomer().name}
          address={edit}
          onCancel={cancel}
          onSuccess={onSuccess}
        />
      </Modal>
      <div className={s.title}>{title}</div>
      {path !== ROUTE_USER_ACCOUNT && !id && (
        <div className={s.addAddress}>Escolha um endereço já cadastrado ou cadastre um novo</div>
      )}

      <br />
      <div className={s.addressesGrid}>
        {addresses.map((item, index) => (
          <AddressCard
            customer={user as User}
            address={item}
            active={id === item.id}
            onEdit={setEdit}
            onSelect={index === 0 && addresses.length === 1 ? () => {} : onSelectAddress}
          />
        ))}
      </div>
      <div>
        {addresses.length === 0 && (
          <div className={s.addAddress}>
            Você não tem nenhum endereço cadastrado, por favor, cadastre seu endereço para continuar p/ o pagamento
          </div>
        )}

        <div>
          <Button
            variant="primary"
            onClick={openCreateAddressForm}
            className={cn(s.button, addresses.length === 0 && s.large)}
          >
            {addresses.length === 0 ? 'Cadastrar endereço' : 'Novo endereço'}
          </Button>
        </div>
      </div>
    </>
  )
}

export default AddressHandler
